module.exports = __webpack_public_path__ + "static/img/picb.1ee98bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/picb.png
// module id = aPPo
// module chunks = 1